import React from 'react';
import { connect } from "react-redux";
import {Card, Container, Form, Input, Message} from "semantic-ui-react";
import * as Validation from "../../../common/utils/Validation";
import {
    setPricingFormValuesV2,
    setPricingFormDropdownValuesV2,
    setPricingFormDescriptionValueV2,
} from "../actions/PricingTablesActions";
import DocumentEditor from "../../../common/partials/DocumentEditor";
import lodash from "lodash";
import Select from "react-select";

export class AddEditPricingFormV2 extends React.Component {

    // create a ref for automatic smooth scrolling to the end of
    // the form in case of error/warning
    messagesEndRef = React.createRef();

    scrollToBottom = () => {
        this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // eslint-disable-next-line no-unused-expressions
        (this.props.formErrorNotification || this.props.formWarningNotification)
            ? this.scrollToBottom() : null
    }

    handleInputChange = (e, { name, value }) => {
        this.props.setPricingForm({ name, value });
    };

    handlePricingTableDropdown = (option, change_obj) => {
        this.props.setPricingFormDropdown(option, change_obj);
    }

    handlePricingTableDescription = (e, { name, value }) => {
        this.props.setPricingFormDescription({ name, value });
    }

    handleDismiss = () => {
        Validation.clearMessages();
    }

    render() {

        const {
            pricingTableObjectV2, aggregationTypeOptions,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification
        } = this.props;

        return (
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <Form.Field
                                    required
                                    control={Input}
                                    type="text"
                                    label="Pricing Table Name"
                                    placeholder="Name"
                                    value={pricingTableObjectV2.name}
                                    name="name"
                                    onChange={this.handleInputChange}
                                />
                                <div className={'required field'}>
                                    <label>Description</label>
                                    <DocumentEditor
                                        required
                                        pricing={true}
                                        resourceType={"description"}
                                        value={pricingTableObjectV2.description}
                                        initialValue={pricingTableObjectV2.description}
                                        placeholderText={"Enter Description"}
                                    />
                                </div>
                            </Card.Content>
                        </Card>
                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Pricing Info:
                                </h4>
                                <Form.Group widths={"equal"}>
                                    <Form.Field required>
                                        <label>Volume Aggregation Type</label>
                                        <Select
                                            onChange={this.handlePricingTableDropdown}
                                            options={aggregationTypeOptions}
                                            placeholder="Select Volume Aggregation Type"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="volume_aggregation_type"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(aggregationTypeOptions, {
                                                value: pricingTableObjectV2.volume_aggregation_type
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Input
                                        required
                                        type="number"
                                        step="0.1"
                                        label="Base Price"
                                        placeholder="$"
                                        value={pricingTableObjectV2.base_price}
                                        name="base_price"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <div ref={this.messagesEndRef}/>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    // hidden={formWarning}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    pricingTableObjectV2: state.billing.addEditPricingTable.pricingTableObjectV2,
    aggregationTypeOptions: state.billing.addEditPricingTable.aggregationTypeOptions,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    setPricingForm: ({ name, value }) => {dispatch(setPricingFormValuesV2({ name, value }))},
    setPricingFormDropdown: (option, change_obj) => {dispatch(setPricingFormDropdownValuesV2(option, change_obj))},
    setPricingFormDescription: ({ name, value }) => {dispatch(setPricingFormDescriptionValueV2({ name, value }))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddEditPricingFormV2);
